import React from 'react';
import "../ExerciseTest/ExerciseTest.scss";
import ExerciseTestStepper from '../../components/ExerciseTestStepper/ExerciseTestStepper';


const ExerciseTest = () => {
  return (
    <>
    <ExerciseTestStepper/>
    </>
  )
}

export default ExerciseTest